import styled from 'styled-components'

import { H2 } from 'lib/ui/primitives'

import theme from 'theme'

const PaperTitle = styled(H2)`
  margin: 30px 0;
  font-weight: ${theme.fontWeights.bold};
  line-height: 1.3;

  &:first-child {
    margin-top: 0;
  }
`

PaperTitle.defaultProps = {}

PaperTitle.propTypes = {}

export default PaperTitle
